/**
 * Minimalerei Cart — Phase Cart 1
 *
 * AJAX-basierte Cart-Updates:
 * - Quantity-Änderung über +/- Buttons oder Input
 * - Item-Removal mit Confirmation
 * - Cart-Reload für korrekte Punkte-Anzeige und Summary
 */

(function () {
  'use strict';

  const SELECTORS = {
    cart: '[data-mp-cart]',
    item: '[data-mp-cart-item]',
    qtyInput: '[data-mp-cart-qty-input]',
    qtyBtn: '[data-mp-cart-qty-action]',
    removeBtn: '[data-mp-cart-remove]',
    discountBtn: '[data-mp-cart-discount-btn]',
    discountInput: '[data-mp-cart-discount-input]',
  };

  function updateItemQuantity(itemKey, quantity, itemElement) {
    if (itemElement) {
      itemElement.classList.add('is-loading');
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart update failed');
        }
        return response.json();
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function (error) {
        console.error('Cart update error:', error);
        if (itemElement) {
          itemElement.classList.remove('is-loading');
        }
      });
  }

  function removeItem(itemKey, itemElement) {
    updateItemQuantity(itemKey, 0, itemElement);
  }

  function initQuantityControls(item) {
    const itemKey = item.dataset.mpCartKey;
    const input = item.querySelector(SELECTORS.qtyInput);
    const buttons = item.querySelectorAll(SELECTORS.qtyBtn);

    if (!input || !buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const action = btn.dataset.mpCartQtyAction;
        const currentValue = parseInt(input.value, 10) || 0;
        let newValue = currentValue;

        if (action === 'increase') {
          newValue = currentValue + 1;
        } else if (action === 'decrease') {
          newValue = Math.max(0, currentValue - 1);
        }

        if (newValue !== currentValue) {
          updateItemQuantity(itemKey, newValue, item);
        }
      });
    });

    let inputTimeout = null;
    input.addEventListener('change', function () {
      const newValue = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = newValue;

      if (inputTimeout) clearTimeout(inputTimeout);
      inputTimeout = setTimeout(function () {
        updateItemQuantity(itemKey, newValue, item);
      }, 300);
    });
  }

  function initRemoveButton(item) {
    const itemKey = item.dataset.mpCartKey;
    const removeBtn = item.querySelector(SELECTORS.removeBtn);

    if (!removeBtn) return;

    removeBtn.addEventListener('click', function () {
      removeItem(itemKey, item);
    });
  }

  function initDiscount(cart) {
    const discountBtn = cart.querySelector(SELECTORS.discountBtn);
    const discountInput = cart.querySelector(SELECTORS.discountInput);
    const errorEl = cart.querySelector('[data-mp-cart-discount-error]');
    const clearBtn = cart.querySelector('[data-mp-cart-discount-clear]');
    const ATTEMPT_KEY = 'mp-cart-attempted-discount';
    const APPLIED_LABEL = '✓ Aktiv';
    const DEFAULT_LABEL = discountBtn ? discountBtn.textContent.trim() : 'Anwenden';

    if (!discountBtn || !discountInput) return;

    const appliedCodesRaw = cart.dataset.mpCartAppliedCodes || '';
    const appliedCodes = appliedCodesRaw
      .split(',')
      .map(function (s) { return s.trim().toUpperCase(); })
      .filter(Boolean);

    function isApplied(code) {
      return appliedCodes.indexOf(code.trim().toUpperCase()) !== -1;
    }

    function setAppliedState() {
      discountBtn.classList.add('is-applied');
      discountBtn.textContent = APPLIED_LABEL;
      if (clearBtn) {
        clearBtn.hidden = false;
        discountInput.classList.add('has-clear');
      }
    }

    function clearAppliedState() {
      discountBtn.classList.remove('is-applied');
      discountBtn.textContent = DEFAULT_LABEL;
      if (clearBtn) {
        clearBtn.hidden = true;
        discountInput.classList.remove('has-clear');
      }
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    if (discountInput.value.trim() && isApplied(discountInput.value)) {
      setAppliedState();
    }

    let attempted = null;
    try { attempted = sessionStorage.getItem(ATTEMPT_KEY); } catch (e) {}
    if (attempted) {
      try { sessionStorage.removeItem(ATTEMPT_KEY); } catch (e) {}
      if (!isApplied(attempted)) {
        discountInput.value = attempted;
        showError('Der Code „' + attempted + '" ist ungültig oder abgelaufen.');
      }
    }

    function applyDiscount() {
      const code = discountInput.value.trim();
      if (!code) return;
      if (isApplied(code)) return;

      try { sessionStorage.setItem(ATTEMPT_KEY, code); } catch (e) {}
      clearError();
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    }

    discountBtn.addEventListener('click', applyDiscount);

    discountInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        applyDiscount();
      }
    });

    discountInput.addEventListener('input', function () {
      clearError();
      if (discountBtn.classList.contains('is-applied') && !isApplied(discountInput.value)) {
        clearAppliedState();
      } else if (!discountBtn.classList.contains('is-applied') && isApplied(discountInput.value)) {
        setAppliedState();
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        clearBtn.disabled = true;
        clearError();
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: '' })
        })
          .then(function () { window.location.reload(); })
          .catch(function () { window.location.reload(); });
      });
    }
  }

  function initCart(cart) {
    const items = cart.querySelectorAll(SELECTORS.item);

    items.forEach(function (item) {
      initQuantityControls(item);
      initRemoveButton(item);
    });

    initDiscount(cart);
  }

  function init() {
    const carts = document.querySelectorAll(SELECTORS.cart);
    carts.forEach(initCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
